import { render } from "./AccountLayout.vue?vue&type=template&id=30e21bb8"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__